import { render, staticRenderFns } from "./ExternalPluginOverflowMenu.vue?vue&type=template&id=59739e1e&scoped=true"
import script from "./ExternalPluginOverflowMenu.vue?vue&type=script&lang=js"
export * from "./ExternalPluginOverflowMenu.vue?vue&type=script&lang=js"
import style0 from "./ExternalPluginOverflowMenu.vue?vue&type=style&index=0&id=59739e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59739e1e",
  null
  
)

export default component.exports